export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <a href="#hero" className="flex items-center gap-3 mb-4 no-underline cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-50 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                91影视看片下载
              </span>
            </a>
            <p className="text-white/50 text-sm leading-relaxed">
              国内领先的免费影视大全追剧平台，提供电影、电视剧、综艺、动漫高清免费在线观看服务。天美麻花星空影视免费观看专区同步更新，让您畅享极致的免费追剧体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#carousel" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">焦点专题</a>
              <a href="#ranking" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">热门榜单</a>
              <a href="#topics" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">话题标签</a>
              <a href="#index" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">影视索引</a>
              <a href="#features" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">平台优势</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">内容分类</h4>
            <nav className="flex flex-col gap-2">
              <a href="#topics" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">电影大全</a>
              <a href="#topics" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">电视剧场</a>
              <a href="#topics" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">综艺娱乐</a>
              <a href="#topics" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">动漫世界</a>
              <a href="#topics" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">纪录片库</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">更多信息</h4>
            <nav className="flex flex-col gap-2">
              <a href="#about" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
              <a href="#contact" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
              <a href="#faq" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
              <a href="#updates" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">更新动态</a>
              <a href="#comments" className="text-white/50 hover:text-accent-400 text-sm transition-colors cursor-pointer whitespace-nowrap">用户评价</a>
            </nav>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10">
          <div className="mb-6">
            <h4 className="font-heading text-sm font-bold text-white/40 mb-3">合作伙伴</h4>
            <div className="flex flex-wrap gap-6">
              <span className="text-white/25 text-xs whitespace-nowrap">天美麻花星空影视</span>
              <span className="text-white/25 text-xs whitespace-nowrap">星空影视联盟</span>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/35 text-xs">
              &copy; {currentYear} 91影视看片下载 - 免费影视大全高清追剧平台 版权所有
            </p>
            <p className="text-white/25 text-xs">
              声明：本站所有内容均来自网络公开资源，仅供用户免费在线观看
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}